import styled from 'styled-components';

import Button from '@components/web/src/atoms/Buttons/Button';
import { CloseButton } from '@components/web/src/atoms/Buttons/CloseButton/CloseButton';
import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { Image } from '@components/web/src/foundations/Image/Image';
import { COLORS, RETAILER_COLORS, SHADOWS } from '@components/web/src/styles';

export const FindMeModalContainer = styled(Flexbox)`
  border-radius: 16px;
  background: ${COLORS.base.white};
  box-shadow: ${SHADOWS.xl};
  height: fit-content;
`;

export const CloseButtonCta = styled(CloseButton)`
  width: 18px;
  height: 18px;
`;

export const SlidingViewport = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
`;

export const MapWrapper = styled(Flexbox)<{ $isShowProduct: boolean }>`
  ${({ $isShowProduct }) =>
    $isShowProduct
      ? `
    position: absolute;
    inset: 0;
    pointer-events: none;
  `
      : `
    position: relative;
    width: 100%;
  `}

  flex-direction: column;
  transition: transform 320ms ease;
  transform: translateY(${({ $isShowProduct }) => ($isShowProduct ? '-150%' : '0%')});
`;

export const ProductLocationMapWrapper = styled(Flexbox)`
  border-radius: 20px;
  background: ${COLORS.base.white};
`;

export const ProductLayer = styled(Flexbox)<{ $visible: boolean }>`
  ${({ $visible }) =>
    $visible
      ? `
    position: relative;
  `
      : `
    position: absolute;
    inset: 0;
    pointer-events: none;
  `}

  transition: 
  opacity 800ms ease-in-out,
  visibility 100ms ease-in-out;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  height: fit-content;
`;

export const ProductImage = styled(Image)<{ $fallback?: boolean }>`
  width: 84px;
  height: 220px;
  object-fit: contain;
  ${({ $fallback }) => $fallback && 'opacity: 0;'}
`;

export const ProductInfo = styled(Flexbox)`
  text-align: left;
`;

export const TextFormatWrapper = styled(Flexbox)`
  width: 150px;
`;

export const ToggleArrowWrapper = styled(Flexbox)<{ $directionUp: boolean }>`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transform-origin: center;
  transition: transform 200ms ease;
  transform: rotate(${({ $directionUp }) => ($directionUp ? '180deg' : '0deg')});
`;

export const TitleWrapper = styled(Flexbox)`
  border-radius: 10px;
  background: ${RETAILER_COLORS.primary[50]};
`;

export const ToggleBtn = styled(Button)`
  padding: 10px 14px;
`;
